//ljzhly-www.qlxing.com
//window.apiV2 = "https://api.qlxing.com/v2";
//window.appid = 'wx2affd66c63a4650f'
//window.secrect = '0caf272962abcbe653a49f99e07b99f5'
//ljzhly-www.zlyun168.com

window.appid = 'wx7549c43e410a5550'
window.secrect = '770b02fd13227be8d5e0c07973d768ec'
window.storeID = '9d5142553d2a80854fc9c160810e8c7012e18170c9e6aec38063c433242b1e1f';

//----生产环境
// window.apiLogin = "https://api.zlyun168.com";
// window.apiV2 = "https://api.zlyun168.com/v2";
window.apiV2 = "https://tour.i-lianjiang.cn:9311/v2";
window.apiLogin = "https://tour.i-lianjiang.cn:9311";
window.api = "https://tour.i-lianjiang.cn/lianjiang_web_i";

window.api2 = "https://tour.i-lianjiang.cn/lianjiang_web_a/i/api"
window.apiimg ="https://tour.i-lianjiang.cn/lianjiang_web_a";

// ---开发环境
// window.apiLogin = "https://api.zlyun168.com";
// window.apiV2 = "https://api.zlyun168.com/v2";
window.apiV2 = "https://tour.i-lianjiang.cn:9311/v2";
window.apiLogin = "https://tour.i-lianjiang.cn:9311";
window.api = "/lianjiang_web_i";
window.api2 = "https://tour.i-lianjiang.cn/lianjiang_web_a/i/api"
window.apiimg ="https://tour.i-lianjiang.cn/lianjiang_web_a";

import Axios from 'axios';
import moment from 'moment';

// var gettoken =

/*var gettoken = function() {
    alert(1);
    var token = "";
    if (localStorage.getItem("userdb") ) {
        let userdb = JSON.parse(localStorage.getItem("userdb"));
        console.log(userdb);
        token = userdb.access_token;
        return token;
    }else {
       // this.$message.error("未登录,请先登录");
    }
}*/
const axios= Axios.create();
//请求拦截器
axios.interceptors.request.use(
    config => {
         console.log(config);
        if(localStorage.getItem("userdb")){
            let token = JSON.parse(localStorage.getItem("userdb")).access_token;
            config.headers.Authorization = 'Bearer ' + token;
        }
        return config
    },
    err => {
        return Promise.reject(err)
    }
);

/*function wxlogin() {
    let url = `${apiV2}/third_parties/wechat/get_url`
    let redirect_url = "https://" + document.domain + "/glyz/redirect.html";
    let params = {
        store_identity: document.domain || "zly.qlxing.com",
        // store_identity: "zly.qlxing.com",
        redirect_url,
        client_id: "4e17b8ae60040835e1cf9b93ecc60edf",
        client_secret: "secret.1",
        extra: decodeURI(window.location.href),
    }
    Axios.get(url, {
        params
    }).then(v => {
        let url = v.data.data.url;
        window.location.href = url;
    })
}*/


export default {
     http:axios,
     axios:axios,
     httpWeahter:Axios.create({
         headers: {
             'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsImNyZWF0ZWQiOjE1ODYyNDgwNDQ5NDIsImV4cCI6MjU4NjI0ODA0NH0.u1edA5t8ww5V9AkQ8oifAP07HJE5U-eUSZC6_ASfb8t9gS1eAE1SzpQZbBNklCAAO-ZMiSgJQcSbtRtrrRaWog'
         }
     }),
    /*axios: Axios,
    //创建axios实例
    http: Axios.create({
        headers: {
            'Authorization': 'Bearer ' +gettoken()
        }
    }),*/
   /* loginwx(){
        //    let redirect_url = encodeURIComponent('https://ljzhly-www.qlxing.com/')+encodeURIComponent('#')+encodeURIComponent(this.$route.fullPath);
        let redirect_url = encodeURIComponent('https://ljzhly-www.zlyun168.com/')+encodeURIComponent('#')+encodeURIComponent(this.$route.fullPath);
        let url = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`
        window.open(url);
    },*/
    loginwx(){
        //    let redirect_url = encodeURIComponent('https://ljzhly-www.qlxing.com/')+encodeURIComponent('#')+encodeURIComponent(this.$route.fullPath);
        //let redirect_url = encodeURIComponent('https://ljzhly-www.zlyun168.com/')+encodeURIComponent('#')+encodeURIComponent(this.$route.fullPath);
        let redirect_url = encodeURIComponent(location.href);
        let url = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`
        window.open(url);
    },
    // wxlogin,
    login(callback, username = "admin", password = "1") {
        let url = apiLogin + "/oauth2/token";

        Axios({
                method: "POST",
                url,
                data: `username=${username}&password=${password}&grant_type=password&client_id=4e17b8ae60040835e1cf9b93ecc60edf&client_secret=secret.1`,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
        ).then((response) => {
            console.log(response);
            let res = response.data.data;
            let userdb = {
                "timein": parseInt(Date.parse(new Date())),
                "access_token": res.access_token,
                "user": res.raw_user
            }
            localStorage.setItem("userdb", JSON.stringify(userdb))
            callback();
        }).catch((error) => {
            this.$message.error("登录失败"+error.response.data.message)
        })


    },
    date2UTC(d) {
        moment.utc(d).format()
    },
    date2Local(d) {
        return moment(d).format("YYYY-MM-DD");
    },
    date3Local(d) {
        return moment(d).format("YYYY-MM-DD HH:mm:ss");
    },

    //对象的深度复制(对象内不包含方法)
    deepClone(value) {
        return JSON.parse(JSON.stringify(value));
    },
    //清除字符串首位空格
    trim(str) {
        return str.replace(/^(\s*)|(\s*)$/g, '');
    },
    //fieldUrl拼接
    fieldUrlStringify(field) {
        let query = "?field=";
        query += field.join("&field=");
        return query;
    },
    getStoreId() {
        let storeId = "";
        storeId = "9d5142553d2a80854fc9c160810e8c7012e18170c9e6aec38063c433242b1e1f"; //廉江
        return storeId;
    },

    getDate(n) {
        let myDate = new Date();
        myDate.setDate(myDate.getDate() - n);
        let Y = myDate.getFullYear().toString();
        let M = (myDate.getMonth() + 1).toString();
        let D = myDate.getDate().toString();
        let YM = Y + '-' + (parseInt(M) + 100).toString().slice(-2);
        let MD = (parseInt(M) + 100).toString().slice(-2) + '-' + (parseInt(D) + 100).toString().slice(-2);
        let YMD = Y + '-' + (parseInt(M) + 100).toString().slice(-2) + '-' + ((parseInt(D) + 100).toString().slice(-2));
        return [Y, M, D, YM, MD, YMD];
    },
    //获取两个日期相隔天数
    getDateBtween(date1, date2) {
        var d1 = new Date(parseInt(date1.slice(0, 4)), parseInt(date1.slice(4, 6)) - 1, parseInt(date1.slice(-2)));
        var d2 = new Date(parseInt(date2.slice(0, 4)), parseInt(date2.slice(4, 6)) - 1, parseInt(date2.slice(-2)));
        var num = Math.abs((d2.getTime() - d1.getTime()) / (1000 * 60 * 60 * 24));
        return num;
    },

    //获取某一天的前n天
    getDateBefore(date, num) {
        var d = new Date(parseInt(date.slice(0, 4)), parseInt(date.slice(4, 6)) - 1, parseInt(date.slice(-2)))
        d.setDate(d.getDate() - num);
        var Y = d.getFullYear();
        var M = d.getMonth() + 1;
        var D = d.getDate();
        var S = Y + (M + 100).toString().slice(-2) + ((D + 100).toString().slice(-2));
        return S;
    },

    regPhone: function (phone) {
        var reg = /^1[345786]\d{9}$/;
        if (reg.test(phone)) {
            return true;
        } else {
            return false;
        }
    },
    regidnumber: function (idnumber) {
        var reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
        if (reg.test(idnumber)) {
            return true;
        } else {
            return false;
        }
    },
    regEmail: function (email) {
        var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
        if (reg.test(email)) {
            return true;
        } else {
            return false;
        }
    },
    regCode: function (code) {
        var reg = /^\d{4,8}$/;
        if (reg.test(code)) {
            return true;
        } else {
            return false;
        }
    },
    arrlength: function (arr) {
        if (arr == undefined) {
            return 0;
        } else if (arr == null) {
            return 0;
        } else {
            if (arr.length == undefined) {
                try {
                    let str = arr + ""
                    return str.length;
                } catch (e) {
                    return 0;
                }
            } else {
                return arr.length
            }
        }
    },
    delHtmlTag: function (str) {
        if (str != undefined && str != null) {
            return str.replace(/<[^>]+>/g, ""); //去掉所有的html标记
        } else {
            return "";
        }

    },
    numbertotime: function (str) {

        let minutes = parseInt(str / 60);
        minutes = minutes < 10 ? "0" + minutes : minutes;
        let seconds = parseInt(str % 60);
        seconds = seconds < 10 ? "0" + seconds : seconds;
        return minutes + ":" + seconds;
    },
    getValue2:function (str) {
        var s = '';
        switch (str) {
            case 'ljgl':
                s = '廉江概览';
                break;
            case 'ljdt':
                s = '廉江动态';
                break;
            case 'jqhd':
                s = '节庆活动';
                break;
            case 'yhlj':
                s = '音画廉江';
                break;
            case 'myjj':
                s = '漫游讲解';
                break;
            case 'lygl':
                s = '旅游攻略';
                break;
            case 'yjfx':
                s = '游记分享';
                break;
            case 'lyxl':
                s = '旅游线路';
                break;
                case 'xcgh':
                    s = '行程规划';
                    break;
            case 'tyfg':
                s = '田园风光';
                break;
            case 'mlxc':
                s = '美丽乡村';
                break;
            case 'cybd':
                s = '出游宝典';
                break;
            case 'cjwt':
                s = '常见问题';
                break;
            case 'lydh':
                s = '旅游电话';
                break;
            case 'lyzn':
                s = '旅游指南';
                break;
            case 'shgn':
                s = '赏花观鸟';
                break;
            case '720':
                s = '虚拟游';
                break;

            case 'cx':
                s = '出行'
                break


        };
      return s;

    }
}
